export enum InviteesGroupEnums {
  UPLOAD_LIST = 'upload_list',
  PRIVILEGED_LIST = 'privileged_list',
}
